<template>
  <v-container
    fluid
    class="pa-md-12"
  >
    <v-row wrap>
      <v-col cols="12">
        <v-card class="pa-5 px-md-12 py-md-6">
          <v-row wrap>
            <v-col cols="12">
              <div
                v-motion
                :initial="{ opacity: 0, x: 10 }"
                :enter="{ opacity: 1, x: 0, scale: 1 }"
                :delay="0"
                class="font-weight-bold"
              >
                Help Page
              </div>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <div class="mb-6">FAQs</div>
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="(faq, idx) in faqs"
                  :key="idx"
                  :title="faq.question"
                  :text="faq.answer"
                  v-motion
                  :initial="{ opacity: 0, x: 10 }"
                  :enter="{ opacity: 1, x: 0, scale: 1 }"
                  :delay="idx * 50"
                ></v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
  const faqs = [
    {
      question: "How do I create a new session?",
      answer:
        'Navigate to the "Create Session" page, choose the topics you would like to be tested on, and follow the instructions to generate your session.',
    },
    {
      question: "How do I view all sessions?",
      answer:
        'From the home page, click on the "View All Sessions" button. This will take you to a page listing all your sessions.',
    },
    {
      question: "How do I open a session in a new tab?",
      answer:
        "Click on the icon next to the session you want to open. This will open the session in a new tab.",
    },
    {
      question: "What happens if I close the tab?",
      answer:
        "You can return back to it anytime. If there is a timer running, it will continue to run in the background and the session will end once the timer runs out.",
    },
    {
      question: "What happens if I end a session with unanswered questions?",
      answer:
        "If you end a session with unanswered questions, a dialog box will appear warning you that all unanswered questions will be considered as attempted but incorrect. You can choose to end the session or close the dialog box and return to the session later.",
    },
    {
      question: "How do I navigate through questions in a session?",
      answer:
        'You can navigate through questions using the "ArrowRight" and "ArrowLeft" keys on your keyboard. The "ArrowRight" key takes you to the next question, and the "ArrowLeft" key takes you back to the previous question.',
    },
  ];
</script>
